"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface LeaseLiabilityTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  {
    id: "lease-ind-as-1",
    question: "Are there any new/amended lease taken by the entity in the current period?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "lease-ind-as-2",
    question: "Are there any related party transactions in leases in the current period?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "lease-ind-as-3",
    question: "Does the entity have any sale or lease-back transaction it has entered into in the current or prior periods?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "lease-ind-as-4",
    question: "Does the entity have any short term lease or leases of low value assets?",
    type: "radio",
    options: ["Yes", "No"]
  }
];

export default function LeaseLiabilityTailoringQuestions({ onBack }: LeaseLiabilityTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Lease Liability - Ind AS"
      title="Lease Liability - Ind AS - Tailoring Questions"
      description="Customize the audit program for Lease Liability - Ind AS"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
